var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsArDelivery = function SvgNnIconFlagsArDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-AR-delivery_svg__Lager_63",
    "data-name": "Lager 63",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-AR-delivery_svg__cls-4{fill:#ffb700;stroke:#cc6d29;stroke-width:.07px}.nn-icon-flags-AR-delivery_svg__cls-5{fill:#cc6d29}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22v33.56H.13z",
    style: {
      fill: "#41aaff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 11.35h49.97v11.1H.25z",
    style: {
      fill: "#fff"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-AR-delivery_svg__rays"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.75 18.59 1.17 2.54s0 .08.08.06 0-.11 0-.11l-1.58-4.26L25 17l.66 1.43h.08a1 1 0 0 0 .01.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.68 18.43h-.28c0 .63.36 1 .31 1.53a2 2 0 0 0 .33 1.1c.07.22-.08.35 0 .38s.21-.14.16-.45-.28-.4-.22-1.09-.22-.81-.21-1.31Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.76 18.43h-.08l.07.16a1 1 0 0 1 .01-.16ZM25.07 18.65l.1 2.8s0 .09.06.09.06-.09.06-.09l.17-4.54H25l.06 1.58h.08Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.14 18.52h-.08v.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.23 21.4s.24-.05.32-.36-.11-.48.21-1.09.1-.84.31-1.3v-.16l-.26-.11c-.26.57 0 1-.3 1.53a1.94 1.94 0 0 0-.11 1.14c-.03.23-.17.3-.17.35ZM24.23 18.1c-.46.43-.43 1-.86 1.31a2.1 2.1 0 0 0-.55 1c-.1.2-.3.19-.27.25s.24.05.43-.2.09-.48.61-.93.42-.74.78-1.08l.06-.16ZM24.47 18.3l-.06.16a.6.6 0 0 1 .12-.1Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.46 21.19c.05 0 .08-.06.08-.06l1.9-4.13-.42-.18-.55 1.48.06.06a.6.6 0 0 0-.12.1l-1 2.62s0 .08.05.11ZM24 17.91l-.12.12h.15Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.89 17.64c-.59.22-.76.71-1.3.88s-.71.57-.89.72-.35.07-.35.14.21.13.48 0 .26-.41.91-.62.67-.52 1.14-.7l.12-.12Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.96 20.18h.1l3.33-3.09-.32-.32L24 17.91v.07h-.15l-1.9 2.05s-.03.11.01.15Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.63 18.54h-.11c0 .6.37.87.3 1.42.15-.44-.21-.77-.19-1.42M25.34 16.87l-.21.09 1.3 2.83zM24.61 19.91c.3-.34.1-.79.37-1.38h-.11c-.2.56.01.94-.26 1.38",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.12 16.91.11 3.12.12-3.12zM23.49 19.48c.42-.2.4-.69.87-1.13l-.08-.09c-.4.45-.35.88-.79 1.22",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.13 16.87-1.09 2.92 1.3-2.84zM22.64 18.62c.46 0 .63-.48 1.24-.71v-.11c-.59.26-.65.68-1.24.82",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.15 16.83-2.13 2.28 2.29-2.12z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-AR-delivery_svg__rays-2",
    "data-name": "rays"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.55 17.43-2.54 1.17s-.08 0-.06.08.11 0 .11 0l4.26-1.58-.18-.42-1.43.66v.08Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.23 17.39a2 2 0 0 0-1.1.33c-.22.07-.35-.08-.38 0s.14.21.45.16.4-.28 1.09-.22.81-.22 1.31-.21l.16-.07v-.28c-.68-.05-1.02.34-1.53.29Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.71 17.44v-.08l-.16.07ZM23.76 16.48c-.57-.26-1 0-1.53-.3a1.93 1.93 0 0 0-1.14-.11c-.23 0-.3-.21-.35-.16s.05.24.36.32.48-.11 1.09.21.84.1 1.3.31h.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.69 16.97 4.54.17v-.46l-1.58.06v.08l-.13-.07-2.8.1s-.09 0-.09.06.06.06.06.06Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.65 16.74h-.16l.13.07ZM20.95 15.14c0 .05.06.08.06.08l4.13 1.9.18-.42-1.48-.55-.06.06a1 1 0 0 0-.1-.12l-2.62-1s-.08 0-.11.05ZM24.04 15.91c-.43-.46-1-.43-1.31-.86a2 2 0 0 0-1-.54c-.2-.11-.19-.31-.25-.28s-.05.24.2.43.49.09.93.61.74.42 1.08.78l.16.06Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.84 16.15-.16-.06a1 1 0 0 1 .1.12ZM24.5 15.57c-.22-.59-.71-.76-.88-1.3s-.57-.71-.72-.89-.07-.35-.14-.35-.13.21 0 .48.41.26.62.91.52.67.7 1.14l.12.12Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.96 13.64v.1l3.09 3.33.32-.32-1.14-1.07h-.07a.7.7 0 0 0 0-.15l-2.05-1.9s-.11-.03-.15.01Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.23 15.68-.12-.12a.7.7 0 0 1 0 .15Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.27 17.01-.08-.21-2.84 1.3zM22.23 17.5c.44.15.77-.21 1.42-.19v-.11c-.65.03-.92.37-1.42.3M22.23 16.29c.34.3.79.1 1.38.37v-.11c-.56-.2-.94.01-1.38-.26",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.23 17.02v-.23l-3.12.11z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.19 17.01.08-.21-2.92-1.09zM23.88 15.96c-.45-.4-.88-.35-1.22-.79.2.42.69.4 1.13.87Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.15 16.98.16-.16-2.28-2.12zM23.52 14.32c0 .46.48.64.71 1.24h.11c-.26-.59-.67-.65-.82-1.24",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-AR-delivery_svg__rays-3",
    "data-name": "rays"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.71 15.23-1.17-2.54s0-.08-.08-.05 0 .1 0 .1L25.04 17l.42-.18-.66-1.43h-.08a1 1 0 0 0-.01-.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.78 15.39h.29c0-.63-.37-1-.32-1.53a2 2 0 0 0-.33-1.1c-.07-.22.08-.35 0-.38s-.21.14-.16.45.28.4.22 1.09.22.81.21 1.31Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 15.39h.08l-.07-.16a1 1 0 0 1-.01.16ZM25.39 15.17l-.1-2.8s0-.09-.06-.09-.06.09-.06.09L25 16.91h.46l-.06-1.58h-.08a1 1 0 0 0 .07-.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.32 15.3h.08v-.16a1 1 0 0 1-.08.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.39 15.17v.16l.26.11c.26-.57 0-1 .3-1.53a1.93 1.93 0 0 0 .11-1.14c0-.23.21-.3.16-.35s-.24.05-.32.36.11.48-.21 1.09-.09.84-.3 1.3ZM26.23 15.72c.46-.43.43-1 .86-1.31a2.1 2.1 0 0 0 .55-1c.1-.2.3-.19.27-.25s-.24-.05-.43.2-.09.49-.61.93-.42.74-.78 1.08l-.06.16ZM25.99 15.52l.06-.16a.6.6 0 0 1-.12.1Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12.64c-.05 0-.08.05-.08.05l-1.9 4.13.42.18.55-1.48-.06-.06a.6.6 0 0 0 .12-.1l1-2.62s0-.08-.05-.1ZM26.57 16.18c.59-.22.76-.71 1.3-.88s.71-.57.89-.72.35-.07.35-.14-.21-.13-.48 0-.26.41-.91.62-.67.52-1.14.7l-.12.12Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.64h-.1l-3.33 3.09.32.32 1.07-1.14v-.07h.14l1.9-2.05s.04-.11 0-.15Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.46 15.91.12-.12h-.14Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.83 15.28h.11c0-.6-.37-.87-.3-1.42-.15.44.21.78.19 1.42M25.13 16.94l.21-.08-1.3-2.84z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.12 16.9h.23l-.11-3.12zM25.48 15.25h.11c.2-.57 0-1 .26-1.43-.3.39-.1.84-.37 1.43",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.34 16.95 1.09-2.93-1.29 2.84zM26.97 14.34c-.42.2-.4.69-.87 1.13l.08.09c.4-.45.35-.88.79-1.22",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.32 16.98 2.13-2.28-2.29 2.12zM27.82 15.2c-.46 0-.63.49-1.24.71v.11c.59-.26.7-.67 1.24-.82",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-AR-delivery_svg__rays-4",
    "data-name": "rays"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.75 16.74c.63 0 1-.36 1.53-.31a2 2 0 0 0 1.1-.33c.22-.07.35.08.38 0s-.14-.21-.45-.16-.4.28-1.09.22-.81.22-1.31.21l-.16.07Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.75 16.46.16-.07h-.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51 15.14h-.11l-4.26 1.58.18.42 1.43-.66v-.08h.16l2.54-1.17s.08-.04.06-.09ZM26.81 17.08h.16l-.13-.07Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 17.34c.57.26 1 0 1.53.3a1.93 1.93 0 0 0 1.14.11c.23 0 .3.21.35.16s-.05-.24-.36-.32-.48.11-1.09-.21-.84-.1-1.3-.31h-.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.86 16.91c0-.06-.09-.06-.09-.06l-4.54-.17v.46l1.58-.06V17l.13.07 2.8-.1s.12 0 .12-.06Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51 18.68c0-.05-.06-.08-.06-.08l-4.13-1.9-.18.42 1.48.55.06-.06a1 1 0 0 0 .1.12l2.62 1s.08 0 .11-.05ZM26.42 17.91c.43.46 1 .43 1.31.86a2.1 2.1 0 0 0 1 .55c.2.1.19.3.26.27s0-.24-.21-.43-.49-.08-.93-.61-.74-.42-1.08-.78l-.16-.06Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.62 17.67.16.06a1 1 0 0 1-.1-.12ZM25.96 18.25c.22.59.71.76.88 1.3s.57.71.72.89.07.35.14.35.13-.21 0-.48-.41-.26-.62-.91-.52-.67-.7-1.14l-.15-.12Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.23 18.14.12.12a.7.7 0 0 1 0-.15Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.18v-.1l-3.09-3.33-.32.32 1.14 1.07h.07a.7.7 0 0 0 0 .15l2.05 1.9s.11.03.15-.01Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.28 17.01 2.84-1.3-2.92 1.09zM28.28 16.32c-.44-.15-.77.21-1.42.19v.11c.6-.03.87-.37 1.42-.3",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.24 16.8v.22l3.12-.11zM28.23 17.53c-.34-.3-.79-.1-1.38-.37v.11c.56.2.94-.01 1.38.26",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.28 16.81-.08.21 2.92 1.08zM26.58 17.91c.45.4.88.35 1.22.79-.2-.42-.69-.4-1.13-.87Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.32 16.83-.16.16 2.28 2.13zM26.94 19.5c0-.46-.49-.63-.71-1.24h-.11c.26.59.67.7.82 1.24",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50 48.15A1.85 1.85 0 1 1 48.15 50 1.85 1.85 0 0 1 50 48.15Z",
    style: {
      fill: "#ffb700",
      stroke: "#cc6d29",
      strokeWidth: ".1px"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__loweyecontour",
    d: "M50.63 49.6a.37.37 0 0 0-.32.17.57.57 0 0 0 .67 0 .48.48 0 0 0-.35-.16Zm0 0c.12 0 .24.06.25.11a.36.36 0 0 1-.51 0 .31.31 0 0 1 .26-.14Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__uppalpebra",
    d: "M50.65 49.52a.4.4 0 0 0-.31.11.3.3 0 0 1-.14.07s0 .06 0 0a.7.7 0 0 0 .17-.11.35.35 0 0 1 .25-.07c.26 0 .4.21.43.2s-.14-.24-.43-.24Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__eyebrow_nose",
    d: "M51.17 49.6a.74.74 0 0 0-1-.11.53.53 0 0 0-.11.24.7.7 0 0 0 .15.51h-.05a1 1 0 0 1-.12-.65 1 1 0 0 1 0-.16.68.68 0 0 1 1.06.14Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "eyebrow nose",
    transform: "translate(-24.77 -33.09)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__pupil",
    d: "M50.63 49.62a.12.12 0 0 1 .13.12.13.13 0 0 1-.13.13.13.13 0 0 1-.13-.13.12.12 0 0 1 .13-.12",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__lowpalpebra",
    d: "M51 49.83a.59.59 0 0 1-.63.09c-.14-.09-.14-.12-.11-.12s.05 0 .17.09a.76.76 0 0 0 .57-.06",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 17.17a.13.13 0 0 0-.11.12.13.13 0 0 0 .13.13.16.16 0 0 0 .11 0 .3.3 0 0 0 .15 0 .34.34 0 0 0 .15 0 .14.14 0 0 0 .11 0 .12.12 0 0 0 .12-.13.12.12 0 0 0-.1-.12.09.09 0 0 1 .06.08.09.09 0 0 1-.09.08.08.08 0 0 1-.08-.08.19.19 0 0 1-.36 0 .08.08 0 0 1-.08.08.09.09 0 0 1-.09-.08.08.08 0 0 1 .06-.08ZM25.09 17.54c-.15 0-.2.13-.33.22a2 2 0 0 0 .23-.14c.1-.06.18 0 .24 0s.14-.07.24 0a2 2 0 0 0 .23.14c-.13-.09-.19-.22-.33-.22a.4.4 0 0 0-.14 0Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m25.04 17.71-.24.05c.26-.06.31 0 .43 0 .11 0 .17-.09.43 0a.73.73 0 0 0-.43 0h-.19Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.81 17.76c.3 0 .15.2.47.2.31 0 .17-.17.47-.2-.31 0-.21.16-.47.16-.24 0-.17-.17-.42-.16Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 18.22a.26.26 0 0 0-.52 0 .27.27 0 0 1 .52 0",
    className: "nn-icon-flags-AR-delivery_svg__cls-5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__eyebrow_nose-2",
    d: "M48.85 49.6a.74.74 0 0 1 1-.11.5.5 0 0 1 .1.24.66.66 0 0 1-.15.51h.06a1 1 0 0 0 .12-.65 1 1 0 0 0-.05-.16.67.67 0 0 0-1 .14Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "eyebrow nose",
    transform: "translate(-24.77 -33.09)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__uppalpebra-2",
    d: "M49.36 49.52a.4.4 0 0 1 .32.11.27.27 0 0 0 .14.07s0 .06 0 0a.6.6 0 0 1-.17-.11.37.37 0 0 0-.26-.07.73.73 0 0 0-.42.2s.14-.24.42-.24Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "uppalpebra",
    transform: "translate(-24.77 -33.09)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__loweyecontour-2",
    d: "M49.35 49.6a.37.37 0 0 0-.31.17.57.57 0 0 0 .67 0 .52.52 0 0 0-.36-.16Zm0 0a.32.32 0 0 1 .26.11.38.38 0 0 1-.52 0 .33.33 0 0 1 .26-.14Z",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "loweyecontour",
    transform: "translate(-24.77 -33.09)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__pupil-2",
    d: "M49.37 49.62a.12.12 0 0 1 .13.12.13.13 0 0 1-.26 0 .12.12 0 0 1 .13-.12",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "pupil",
    transform: "translate(-24.77 -33.09)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AR-delivery_svg__lowpalpebra-2",
    d: "M49 49.83a.59.59 0 0 0 .63.09c.14-.09.14-.12.11-.12s-.06 0-.17.09a.76.76 0 0 1-.57-.06",
    className: "nn-icon-flags-AR-delivery_svg__cls-5",
    "data-name": "lowpalpebra",
    transform: "translate(-24.77 -33.09)"
  })));
};
export default SvgNnIconFlagsArDelivery;